import React from 'react';
import PropTypes from 'prop-types';
import { TopToolbar, ListButton } from 'react-admin';

const SurveyActions = ({ basePath, data }) => (
  <TopToolbar>
    <ListButton basePath={basePath} record={data} />
  </TopToolbar>
);

SurveyActions.propTypes = {
  basePath: PropTypes.string,
  data: PropTypes.shape({}),
};

SurveyActions.defaultProps = {
  basePath: '',
  data: {},
};

export default SurveyActions;
